import { ICustomFieldSearchParams } from './interface';

export const HEAD_TABLE_PROPS = [
  { id: 'id', label: 'ID', align: 'center' },
  { id: 'order', label: 'Thứ tự', align: 'center' },
  { id: 'name', label: 'Tiêu đề', align: 'left' },
  { id: 'key', label: 'Key', align: 'center' },
  { id: 'type', label: 'Kiểu dữ liệu', align: 'center' },
  { id: 'source', label: 'Source', align: 'center' },
  { id: 'status', label: 'Trạng thái', align: 'center' },
  { id: 'action', label: 'Action', align: 'center' },
];

export const DEFAULT_SEARCH_VALUE: ICustomFieldSearchParams = {
  name: '',
  type: '',
  status: '',
  source: '',
  sortByOrder: '',
};
